module.exports = __webpack_public_path__ + "img/produtos_higiene_green.8f1256d9.svg";